import GenericTableResponse from "@/models/api/GenericTableResponse";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { Expose, Type } from "class-transformer";

export class OrderItemTemporaryAttributes {
  @IsString()
  @Expose()
  tmpId!: string;
  @IsOptional()
  @IsNumber()
  @Expose()
  attributePrototypeId!: number | null;
  @IsNumber()
  @Expose()
  dataType!: number;
  @IsOptional()
  @IsString()
  @Expose()
  defaultValue!: string | null;
  @IsString()
  @Expose()
  label!: string;
  @IsOptional()
  @IsString()
  @Expose()
  value!: string | null;
  @IsNumber()
  @Expose()
  ordinal!: number;
  @IsBoolean()
  @Expose()
  isPrintable!: boolean;
  @IsBoolean()
  @Expose()
  isRequired!: boolean;
}

export class TradeTermTemporary {
  @Expose()
  orderItemId!: string;
  @Expose()
  serviceTypeId!: number | null;
  @Expose()
  value!: number;
  @Expose()
  percentValue!: number;
  @Expose()
  stayOnOrder!: boolean;
  @Expose()
  isPercentage!: boolean;
  @Expose()
  separateItem!: boolean;
  @Expose()
  isHidden!: boolean;
  @Expose()
  calculatedFrom!: number;
  @Expose()
  applyTo!: number;
  @Expose()
  isManual!: boolean;
  @Expose()
  addOnlyPossible!: boolean;
  @Expose()
  currency!: string;
  @Expose()
  quantity!: number;
  @Expose()
  type!: number;
  @Expose()
  name!: string;
  @IsBoolean()
  @Expose()
  priceModifierToRootItem!: boolean;
}

export class OrderItemPart {
  @IsString()
  @Expose()
  id!: string;
  @IsOptional()
  @IsString()
  @Expose()
  parentOrderItemId!: string | null;
  @IsString()
  @Expose()
  name!: string;
  @IsNumber()
  @Expose()
  ordinal!: number;
  @IsString()
  @Expose()
  vat!: string;
  @IsOptional()
  @IsString()
  @Expose()
  unit!: string | null;
  @IsNumber()
  @Expose()
  quantity!: number;
  @IsOptional()
  @IsNumber()
  @Expose()
  bookingItemId!: null | number;
  @IsOptional()
  @Expose()
  importedFromDocumentId!: null | number;
  @IsNumber()
  @Expose()
  netPriceInCurrency!: number;
  @IsNumber()
  @Expose()
  netValueInCurrency!: number;
  @IsNumber()
  @Expose()
  vatAmountInCurrency!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsOptional()
  @IsNumber()
  @Expose()
  ownerId!: number | null;
  @Type(() => OrderItemTemporaryAttributes)
  @ValidateNested()
  @Expose()
  orderItemAttributes!: Array<OrderItemTemporaryAttributes>;
  @Type(() => OrderItemPart)
  @ValidateNested()
  @Expose()
  orderItems!: Array<OrderItemPart>;
  @IsOptional()
  @Type(() => TradeTermTemporary)
  @ValidateNested()
  @Expose()
  tradeTerm!: TradeTermTemporary;

  @IsNumber()
  @Expose()
  serviceTypeId!: number;
  @IsString()
  @Expose()
  serviceTypeCode!: string;

  //dane potrzebne do edit order item
  @IsString()
  @Expose()
  currency!: string;
  @IsString()
  @Expose()
  exchangeDate!: string;
  @IsNumber()
  @Expose()
  exchangeRate!: number;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsNumber()
  @Expose()
  modifier!: number;
  @IsNumber()
  @Expose()
  netPrice!: number;
  @IsNumber()
  @Expose()
  netValue!: number;
  @IsNumber()
  @Expose()
  purchaseNetPrice!: number;
  @IsOptional()
  @IsString()
  @Expose()
  purchaseNetPriceCurrency!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  purchaseNetPriceExchangeDate!: string | null;
  @IsNumber()
  @Expose()
  purchaseNetPriceExchangeRate!: number;
  @IsNumber()
  @Expose()
  purchaseNetPriceInCurrency!: number;
  @IsNumber()
  @Expose()
  vatAmount!: number;
}

export class OrderGetTemporaryOrderItemsResponse extends GenericTableResponse<OrderItemPart> {
  @Type(() => OrderItemPart)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items: OrderItemPart[];
  @IsString()
  @Expose()
  summary!: string;
}
